import React, { createContext, useContext } from "react";
import useWebSocket from "react-use-websocket";
import { getInfra } from "../../../common";
import { getBaseUrl } from "../../../environment";
import { MyContext } from "../../pages/liveChat";
import { PropaneTankTwoTone } from "@mui/icons-material";

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const {
    candidate,
    setCandidate,
    chat,
    setChat,
    collegeId,
    collegeHash,
    fetchAgain,
    setFetchAgain,
    leadMessage,
    setLeadMessage,
    validateAuth,
    userDetails,
  } = useContext(MyContext);
  const { infra, institute_hash } = getInfra();
  let meritto_node_url = getBaseUrl("NODE_LIVECHAT", infra);
  if (infra == "local1") {
    meritto_node_url = `ws://localhost:3001/${collegeId}/${userDetails?.UserId}/chat`;
  } else {
    meritto_node_url = meritto_node_url.replace("https://", "wss://");
    meritto_node_url = `${meritto_node_url}/${collegeId}/${userDetails?.UserId}/chat`;
  }
  const webSocket = useWebSocket(meritto_node_url, {
    onOpen: () => {
      console.log("WebSocket connection established.");
    },
    onClose: () => {
      console.log("Connection got disconnected");
    },
  });

  return (
    <WebSocketContext.Provider value={webSocket}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
